import Request from "@wwdev/bootstrap/Request";
import Events from "@wwdev/bootstrap/Events";

class Overview {
	stickyOffsetHeight = 100;

	type = 'pagination';

	constructor(config) {
		this.config = Object.assign({
			scope: '[data-contentable="scope"]',
			grid: '[data-contentable="grid"]',
			pagination: '[data-contentable="pagination"]',
			tags: '[data-contentable="tags"]',
			tag: '[data-contentable="tag"]',
			activeTags: '[data-contentable="active-tags"]',
			resetTags: '[data-contentable="reset-tags"]',
			resetTagsGroup: '[data-contentable="reset-tags-group"]',
			tag: '[data-contentable="tag"]',
			tagGroup: '[data-contentable="tag-group"]',
			pageLink: '.page-link',
			loadMore: '[data-contentable="load-more"]',
			toggleTags: '[data-contentable="toggleTags"]'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initRequest();
		this.addEventListeners();
	}

	initRequest() {
		this.request = new Request();
		this.request.doRequest = this.doRequest.bind(this);
	}

	addEventListeners() {
		let namespace = this._getEventListenersNamespace();

		$(document).off(`.${namespace}`)
			.on(`click.${namespace}`, `${this.config.scope} ${this.config.loadMore}`, this.handleLoadMore.bind(this))
			.on(`click.${namespace}`, `${this.config.scope} ${this.config.pageLink}`, this.handlePage.bind(this))
			.on(`change.${namespace}`, `${this.config.scope} ${this.config.tag}`, this.handleTagChange.bind(this))
			.on(`click.${namespace}`, `${this.config.scope} ${this.config.resetTags}`, this.resetTags.bind(this))
			.on(`click.${namespace}`, `${this.config.scope} ${this.config.resetTagsGroup}`, this.resetTags.bind(this))
			.on(`click.${namespace}`, `${this.config.scope} ${this.config.toggleTags}`, this.toggleTags.bind(this))
	}

	handleLoadMore(event) {
		event.preventDefault();

		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);

		this.request.setByKeyValue('page', $button.data('next-page'));
		this.type = 'load-more';

		this.reload($scope);
	}

	handlePage(event) {
		event.preventDefault();

		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		this.type = 'pagination';
		this.request.setByKeyValue('page', $button.data('page'));
		this.reload($scope);
		this.resetScroll($scope);
	}

	async handleTagChange(event) {
		let $input = $(event.currentTarget);
		let group = $input.data('group');

		let data = {};
		if ($input.is('select')) {
			$input.find('option:selected').each((index, element) => {
				let $element = $(element);
				data[$element.data('id')] = $element.data('title');
			});
		} else {
			$input.closest(this.config.tagGroup).find(`:input[type="checkbox"]:checked`).each((index, element) => {
				let $element = $(element);
				data[$element.data('id')] = $element.data('title');
			});
		}

		if (!this.request.request.tags) {
			this.request.request.tags = {};
		}

		if (Object.keys(data).length > 0) {
			this.request.request.tags[group] = data;
		} else {
			try {
				delete this.request.request.tags[group];
			} catch (e) { }
		}

		if (Object.keys(this.request.request.tags).length < 1) {
			try {
				delete this.request.request.tags;
			} catch (e) { }
		}

		let $scope = $input.closest(this.config.scope);
		this.type = 'pagination';
		this.request.setByKeyValue('page', 1);
		await this.reload($scope);
		this.resetScroll($scope);
	}

	async resetTags(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let group = $button.data('group');

		try {
			if (group) {
				delete this.request.request.tags[group];
			} else {
				delete this.request.request.tags;
			}
		} catch (e) { }

		let $scope = $button.closest(this.config.scope);

		this.type = 'pagination';
		this.request.setByKeyValue('page', 1);
		await this.reload($scope);
		this.resetScroll($scope);
	}

	resetScroll($scope) {
		$([document.documentElement, document.body]).animate({
			scrollTop: $scope.offset().top - this.stickyOffsetHeight
		}, 250);
	}

	toggleTags(event) {
		event.preventDefault();
		$('body').toggleClass('contentable-tags-open');
	}

	async reload($scope) {
		this.request.handleResponse = this.handleResponse.bind(this, $scope);
		await this.beforeCallback();
		await this.request.doRequest($scope);
		await this.afterCallback();
		Events.trigger('wwdev.contentable.reloaded');
	}

	beforeCallback() { }

	afterCallback() {
		let request = JSON.parse(JSON.stringify(this.request.request));

		if (this.type == 'load-more') {
			try {
				delete request.page;
			} catch (e) { }
		}

		history.pushState(request, 'step', window.location.pathname + '?' + jQuery.param(request));
	}

	async doRequest($scope) {
		await $.ajax({
			url: window.location.pathname,
			data: this.request.request,
			success: this.handleResponse.bind(this, $scope)
		});
	}

	handleResponse($scope, response) {
		if (this.type == 'pagination') {
			this.handleResponsePagination($scope, response);
		} else if (this.type == 'load-more') {
			this.handleResponseLoadMore($scope, response);
		}
	}

	handleResponseLoadMore($scope, response) {
		$scope.find(this.config.grid).append(response.grid);
		$scope.find(this.config.pagination).html(response.pagination);
	}

	handleResponsePagination($scope, response) {
		$scope.find(this.config.grid).html(response.grid);
		$scope.find(this.config.pagination).html(response.pagination);
		$scope.find(this.config.tags).html(response.tags);
		$scope.find(this.config.activeTags).html(response.active_tags);
	}

	_getEventListenersNamespace() {
		return 'contentable';
	}
}

export default Overview;
